export default __webpack_public_path__ + "static/media/09.30d4ad24.mp3";